<script lang="ts">
    import {authBlobUrl, authFetch} from "../Auth";
    import {getRouteById} from "../Nav";
    import {MessageStatus, strToLocaleDateTime} from "../Utils";
    import AuthSource from "../Component/AuthSource.svelte";
    import AuthImage from "../Component/AuthImage.svelte";

    export let params: {}
    let promise = authFetch('/contacts', {
        method: 'POST',
        body: JSON.stringify(params)
    }).then((response)=>{
        if(response.ok){
            return response.json()
        }else{
            throw new Error(response.statusText)
        }
    })
</script>
<div class="container-fluid mt-2">
    <table class="table table-bordered table-sm">
        <tbody>
            <tr>
                <th>telegram_id</th>
                <td>{params.telegram_id}</td>
            </tr>
            <tr>
                <th>phone</th>
                <td>{params.phone}</td>
            </tr>
            {#await promise}{''}{:then data}
            {#each data.contacts as contact}
                <tr>
                    <th>username</th>
                    <td>{contact.username}</td>
                </tr>
                <tr>
                    <th>name</th>
                    <td>{contact.first_name} {contact.last_name}</td>
                </tr>
            {/each}
            {/await}
        </tbody>
    </table>
    {#await promise}
        <div class="text-center">
            <div class="spinner-grow"></div>
        </div>
    {:then data}

        <table class="table table-bordered table-sm">
            <thead>
                <tr>
                    <th colspan="100" class="text-center">В списках контактів</th>
                </tr>
                <tr>
                    <th colspan="2" style:width="99%">Ціль</th>
                    <th>Чат</th>
                    <th>Повідомлень</th>
                    <th>Контакт</th>
                </tr>
            </thead>
            <tbody>
            {#if data.contacts.length === 0}
                <tr>
                    <th colspan="100" class="text-center">Немає в контактах</th>
                </tr>
            {/if}
            {#each data.contacts as contact}
                <tr>
                    <td>{contact.user?.id}</td>
                    <td>
                        {#each contact.user?.backwardContacts ?? [] as contact}
                            <a class="btn btn-sm btn-primary m-1"
                               href="#{getRouteById('UserContacts').hash(contact.user?.id, {phrase: contact.telegram_contact_id})}">
                                {contact.first_name} {contact.last_name} {contact.username}
                                <i class="bi bi-chevron-left"></i>
                                {contact.user?.username ?? (
                                    contact.user?.names?.length > 0 ?
                                        contact.user?.names[0]?.name :
                                        contact.user?.telegram_id
                                )}
                            </a>
                        {/each}
                        {#each contact.user?.names ?? [] as user_name}
                            <button class="btn btn-sm btn-outline-dark m-1 disabled">{user_name.name}</button>
                        {/each}
                    </td>
                    <td><a class="btn btn-sm btn-primary"
                           href="#{getRouteById('UserChats').hash(contact.user?.id, contact.chat?.id)}">Чат</a></td>
                    <td>{contact.chat?.total_messages}</td>
                    <td class="text-nowrap">{contact.first_name} {contact.last_name} {contact.username}</td>
                </tr>
                <tr>
                    <td colspan="2">
                        <table class="table table-bordered table-sm m-0">
                            {#each contact.user?.messages ?? [] as message}
                                <tr style="white-space: nowrap;">
                                    <td style:width="99%">{MessageStatus[message.status] ?? ''}</td>
                                    <td>{message.sent_at ? strToLocaleDateTime(message.sent_at): ''}</td>
                                    <td>{message.telegram_deleted_at ? strToLocaleDateTime(message.telegram_deleted_at) : ''}</td>
                                    <td>{message.receiver_read_at ? strToLocaleDateTime(message.receiver_read_at) : ''}</td>
                                    <td>{message.receiver_deleted_at ? strToLocaleDateTime(message.receiver_deleted_at): ''}</td>
                                </tr>
                            {/each}
                        </table>
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
        <table class="table table-bordered table-sm">
            <thead>
                <tr>
                    <th colspan="100" class="text-center">В списках цілей</th>
                </tr>
                <tr>
                    <th colspan="2" style:width="99%">Ціль</th>
                </tr>
            </thead>
            <tbody>
            {#if data.users.length === 0}
                <tr>
                    <th colspan="100" class="text-center">Немає в цілях</th>
                </tr>
            {/if}
            {#each data.users as user}
                <tr>
                    <td>{user.id}</td>
                    <td>
                        {#each user.backwardContacts as contact}
                            <a class="btn btn-sm btn-primary m-1"
                               href="#{getRouteById('UserContacts').hash(user.id, {phrase: contact.telegram_contact_id})}">
                                {contact.first_name} {contact.last_name} {contact.username}
                                <i class="bi bi-chevron-left"></i>
                                {user.username ?? (
                                    user.names.length > 0 ? user.names[0].name : user.telegram_id
                                )}
                            </a>
                        {/each}
                        {#each user.names as user_name}
                            <button class="btn btn-sm btn-outline-dark m-1 disabled">{user_name.name}</button>
                        {/each}
                    </td>
                </tr>
                <tr>
                    <td colspan="2">
                        <table class="table table-bordered table-sm m-0">
                            {#each user.messages as message}
                                <tr style="white-space: nowrap;">
                                    <td style:width="99%">{MessageStatus[message.status] ?? ''}</td>
                                    <td>{message.sent_at ? strToLocaleDateTime(message.sent_at): ''}</td>
                                    <td>{message.telegram_deleted_at ? strToLocaleDateTime(message.telegram_deleted_at) : ''}</td>
                                    <td>{message.receiver_read_at ? strToLocaleDateTime(message.receiver_read_at) : ''}</td>
                                    <td>{message.receiver_deleted_at ? strToLocaleDateTime(message.receiver_deleted_at): ''}</td>
                                </tr>
                            {/each}
                        </table>
                    </td>
                </tr>
            {/each}
            </tbody>
        </table>
    {:catch error}
        <div class="alert alert-danger">
            {error}<br/>
            Не вдалося завантажити данні контакта {JSON.stringify(params)}
        </div>
    {/await}
</div>
